module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d4fa08c40e2fac41e67fb4f143535d0.gif";